import { render, staticRenderFns } from "./PasswordSuccess.vue?vue&type=template&id=a2b03004&"
import script from "./PasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./PasswordSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports